/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

type Props = {
  aspectRatio: number;
  isFullscreen?: boolean;
};

/**
 * A box that maintains a fixed aspect ratio.
 * @param param0
 * @returns
 */
const FixedAspectRatioBox = React.forwardRef<HTMLDivElement, React.PropsWithChildren<Props>>(
  function FixedAspectRatioBox({ aspectRatio, children, isFullscreen }, forwardedRef) {
    const styles = {
      root: css`
        width: 100%;
        position: relative;
        padding-top: ${100 / aspectRatio}%;
        overflow: hidden;
      `,

      aspectRatioBox: css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
      `,
    };

    return (
      <div css={[styles.root, isFullscreen ? { height: '100%', paddingTop: 0 } : {}]} ref={forwardedRef}>
        <div css={[styles.aspectRatioBox, isFullscreen ? { position: 'relative' } : {}]}>{children}</div>
      </div>
    );
  }
);

export default FixedAspectRatioBox;
